/******/ (() => { // webpackBootstrap
/*!***************************************!*\
  !*** ./zrc/scripts/templates/cart.js ***!
  \***************************************/
class Cart extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.quantityInput();
  }
  quantityInput() {
    var typingTimer;
    var doneTypingInterval = 1000;
    var input = $('.cart__qty-input');
    input.on('keyup', function () {
      window.clearTimeout(typingTimer);
      typingTimer = window.setTimeout(() => {
        doneTyping($(this));
      }, doneTypingInterval);
    });
    input.on('keydown', () => {
      window.clearTimeout(typingTimer);
    });
    function doneTyping($input) {
      input.prop('disabled', true).addClass('disabled');
      var value = Number($input.val());
      if (value !== "" && value > 0) {
        $input.trigger('change');
      } else {
        $input.val(1);
        window.setTimeout(() => {
          $input.trigger('change');
        }, 100);
      }
    }
  }
}
if (window.customElements.get('cart-section') == null) {
  window.customElements.define('cart-section', Cart);
}
/******/ })()
;